<template>
    <v-app>
        <v-container fluid fill-height>
            <v-layout flex align-center justify-center>
                <v-flex xs12 sm4 elevation-6>
                    <v-toolbar class="orange accent-3">
                        <v-toolbar-title class="white--text">
                            <font size="4">
                                <v-icon dark>mdi-bus</v-icon>
                                ติดตามสถานะการจัดส่งสินค้า
                            </font>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card>
                        <v-card-text pt-4>
                            <v-layout justify-center>
                                <v-flex>
                                    <v-text-field v-model="searchPO" label="เลขที่ PO:" color="orange accent-3" 
                                    @keypress.enter="getPO" ref="searchPO" @input="upperPO"
                                    :rules="poRules" required></v-text-field>
                                </v-flex>
                                <v-flex xs1 text-center mt-3>
                                    <v-btn fab small text color="orange accent-3" @click="getPO">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-dialog v-model="showResult" width="350">
                <v-card>
                    <br>
                    <v-card-text>
                        <v-layout>
                            <v-flex><strong>วันที่ส่งสินค้า:</strong></v-flex>
                            <v-flex text-right>{{date}}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>ชื่อคนขับรถ:</strong></v-flex>
                            <v-flex text-right>{{driverName}}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>ทะเบียนรถ:</strong></v-flex>
                            <v-flex text-right>{{regNum}}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>ชื่อลูกค้า:</strong></v-flex>
                            <v-flex text-right>{{custName}}</v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex><strong>เบอร์โทรศัพท์ลูกค้า:</strong></v-flex>
                            <v-flex text-right>{{custTel}}</v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-overlay v-model="showProgress">
                <template>
                    <v-progress-circular color="orange accent-3" :size="50" indeterminate></v-progress-circular>
                </template>
            </v-overlay>

            <!-- Dialog Error -->
            <v-dialog v-model="showError" width="unset">
                <div class="text-center">
                    <v-card>
                        <v-card-text>
                            <v-layout>
                                <v-flex>
                                    <v-icon color="red" :size="45">mdi-close-circle-outline</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    {{msgError}}
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>
        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
export default {
    data(){
        return{
            custName: '',
            custTel: '',
            driverName: '',
            regNum: '',
            date: '',
            showResult: false,
            msgError: '',
            showError: false,
            showProgress: false,
            searchPO: '',
            poRules: [
                (v) => !!v || 'โปรดกรอกเลขที่ PO',
            ],
        }
    },
    methods:{
        getPO(){
            let app = this
            if(!app.$refs.searchPO.validate()){
                app.$nextTick(()=>app.$refs.searchPO.focus())
            }
            else{
                app.showProgress = true
                db.collection("deliveryTimeline").where("poNo", "==", app.searchPO).get()
                .then(query=>{
                    if(!query.docs[0]){
                        app.showProgress = false
                        app.msgError = "ไม่พบข้อมูล"
                        app.showError = true
                        setTimeout(()=>{
                            app.searchPO = ''
                            app.showError = false
                            app.$nextTick(()=>app.$refs.searchPO.focus())
                        },1000)
                    }
                    else{
                        app.showProgress = false
                        let dateDelivery = ''
                        query.forEach(doc=>{
                            let data = doc.data()
                            dateDelivery = data.date
                            app.driverName = data.driverName
                            app.regNum = data.regNum
                            app.custName = data.custName
                            app.custTel = data.custTel

                            let splitDate = dateDelivery.split("-")
                            let date = splitDate[2].substr(0,1) == 0 ? splitDate[2].substr(1,1) : splitDate[2]
                            let month = splitDate[1]
                            let year = splitDate[0]*1 + 543
                            switch(month){
                                case '01':{
                                    month = 'มกราคม'
                                    break
                                }
                                case '02':{
                                    month = 'กุมภาพันธ์'
                                    break
                                }
                                case '03':{
                                    month = 'มีนาคม'
                                    break
                                }
                                case '04':{
                                    month = 'เมษายน'
                                    break
                                }
                                case '05':{
                                    month = 'พฤษภาคม'
                                    break
                                }
                                case '06':{
                                    month = 'มิถุนายน'
                                    break
                                }
                                case '07':{
                                    month = 'กรกฎาคม'
                                    break
                                }
                                case '08':{
                                    month = 'สิงหาคม'
                                    break
                                }
                                case '09':{
                                    month = 'กันยายน'
                                    break
                                }
                                case '10':{
                                    month = 'ตุลาคม'
                                    break
                                }
                                case '11':{
                                    month = 'พฤศจิกายน'
                                    break
                                }
                                case '12':{
                                    month = 'ธันวาคม'
                                    break
                                }
                            }
                            app.date = date + " " + month + " " + year
                        })
                        app.showResult = true
                    }
                })
            }
        },

        upperPO(){
            this.searchPO = this.searchPO.toUpperCase()
        }
    },
    mounted(){
        // this.$nextTick(()=>this.$refs.searchPO.focus())
    }
}
</script>